import { ApptBannerData } from '@/types';
import { ApptScheduleSteps } from './enums';

const AppptBannerInstructions: ApptBannerData[] = [
  {
    name: ApptScheduleSteps.SELECT_TEAM_MEMBER,
    message: 'Choose a Drees Team member to meet with.',
    icon: false
  }, {
    name: ApptScheduleSteps.SELECT_DATE,
    message: 'Choose a day that works for you.',
    icon: false
  }, {
    name: ApptScheduleSteps.SELECT_TIME,
    message: 'Choose a time that works for you.',
    icon: false
  }, {
    name: ApptScheduleSteps.APPOINTMENT_SCHEDULED,
    message: 'An appointment has been scheduled, and a calendar invite has been sent to you.',
    icon: true
  }, {
    name: ApptScheduleSteps.APPOINTMENT_RESCHEDULED,
    message: 'Appointment has been rescheduled and a calendar invite is on its way to you.',
    icon: true
  }
];

const NoApptDatesAvailable = {
  message: "If you're having difficulties with the available dates, please ",
  linkText: 'contact us.',
  link: '/'
};

const AppointmentMessages = {
  DateNotAvailable: 'The appointment date selected is not within the necessary scheduling period. To avoid delays, choose a different date.',
  MemberNotActive: 'Your assigned team member is no longer active. Please contact us.',
  InitialAppointmentNotScheduled: 'This appointment cannot be scheduled at this time. Please schedule your initial appointment first.',
  NoTeamMember: 'You do not have any assigned team member. Please contact us.'
};

const ApptStatusMessage = {
  Completed: 'Completed',
  AdminScheduled: 'A Drees team member will reach out to schedule.',
  NotAvailable: 'Not available yet',
  Pending: 'Schedule pending',
  Immutable: 'Contact your Drees team to modify this appointment'
};

export {
  AppptBannerInstructions,
  NoApptDatesAvailable,
  AppointmentMessages,
  ApptStatusMessage
};
